import { useState, useEffect } from 'react';
import styled from './index.module.scss';
import { message } from '@/components/UI/Message';
import { useGlobal } from '@/utils/useGlobal';
import { getListSecKillProducts, getLockInfo } from '@/service/vip';
import wss from '@/utils/mqtt-client';
import { getWSSUrl } from '@/utils/countryRegion';
import topics from '@/utils/mqtt-client/crowd-funding-topics';
import { formatPrice } from '@/components/EcocreditsMonthlyMadness/utils';
import getLocal from '@/app/utils/getLocal';
import { euLocaleList } from '@/constants/appreciationDay';
import FlashSaleHeader from '@/components/EcoCredits/CommonElement/EUFlashSale/FlashSaleHeader';
import FlashSaleCountdown from '@/components/EcoCredits/CommonElement/EUFlashSale/FlashSaleCountdown';
import { useMonthlyStore, useMonthlyDispatch } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';
import EUProduct from './Products';

import type { ILockInfo } from '@/components/EcocreditsMonthlyMadness/type';

const ExclusiveFlashSale = () => {
    const { locale } = getLocal();
    const { getSystemTime } = useGlobal();
    const { isLogin, secKillisBegin, secKillProduct } = useMonthlyStore();
    const dispatch = useMonthlyDispatch();

    const [lockInfo, setLockInfo] = useState<ILockInfo>({
        points: '0',
        unLock: isLogin,
    });

    // 秒杀时间
    const [timeInfo, setTimeInfo] = useState({
        secKillStartTime: 0,
        secKillEndTime: 0,
    });

    const handleData = (data: any) => {
        if (!data) return;
        const { productList, secKillStartTime, secKillEndTime } = data;
        const now = getSystemTime();

        let begin = false;

        // jp忽略
        if (now > Number(secKillStartTime)) begin = true;
        if (now > Number(secKillEndTime)) {
            dispatch({
                type: 'changeSecKillProduct',
                payload: [],
            });
            dispatch({
                type: 'changeSecKillisBegin',
                payload: false,
            });
            return;
        }

        productList.map((item: any, index: number) => {
            const newItem = { ...item };
            // 欧洲最后一个产品要全程展示价格
            const specialProduct = euLocaleList.includes(locale) && index === 4;

            item.discount = item.discountPercent;
            item.memberPrice2 = formatPrice(item.memberPrice, locale);
            if (specialProduct) item.memberPrice2 = formatPrice(item.memberPrice, locale);
            item.price2 = formatPrice(item.price, locale);
            item.disparityPrice = formatPrice(String(parseFloat(newItem.compareAtPrice) - parseFloat(newItem.memberPrice)), locale);
            item.compareAtPrice2 = formatPrice(item.compareAtPrice, locale);
        });

        dispatch({
            type: 'changeSecKillProduct',
            payload: productList,
        });
        dispatch({
            type: 'changeSecKillisBegin',
            payload: begin,
        });

        setTimeInfo({
            secKillStartTime: Number(secKillStartTime) || 0,
            secKillEndTime: Number(secKillEndTime) || 0,
        });
    };

    const handleEnd = () => {
        mqttUnsubscribe('seckill');
        if (!secKillisBegin) {
            dispatch({
                type: 'changeSecKillisBegin',
                payload: true,
            });
        } else {
            dispatch({
                type: 'changeSecKillProduct',
                payload: [],
            });
        }
    };

    const { receiver, mqttUnsubscribe, mqttSubscribe } = wss({
        url: String(getWSSUrl(locale)),
        topics,
        locale,
        subscribes: ['seckill'],
    });

    useEffect(() => {
        if (!receiver || !receiver.data) return;
        handleData(receiver.data);
    }, [receiver]);

    const initData = () => {
        getListSecKillProducts(locale).then((res) => {
            if (res.code !== '0') {
                message.error(res.message);
                return;
            }
            handleData(res.data);
        });

        if (!isLogin) return;
        getLockInfo(locale).then((res) => {
            if (res.code !== '0') {
                message.error(res.message);
                return;
            }
            // 只要登陆了就解锁
            if (locale !== 'za') res.data.unLock = isLogin;
            setLockInfo(res.data);
        });
    };

    useEffect(() => {
        initData();
        mqttSubscribe('seckill');
        return () => mqttUnsubscribe('seckill');
    }, []);

    if (!secKillProduct || secKillProduct.length === 0) return <></>;

    return (
        <div className={`${styled.exclusive_flash_sale}`}>
            <FlashSaleHeader />
            <FlashSaleCountdown timeInfo={timeInfo} handleEnd={handleEnd} />
            <EUProduct lockInfo={lockInfo} />
        </div>
    );
};

export default ExclusiveFlashSale;
